import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { AboutPage } from './pages/AboutPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/services" element={<ServicesPage data-id="element-5" />} data-id="element-4" />
        <Route path="/about" element={<AboutPage data-id="element-7" />} data-id="element-6" />
      </Routes>
    </Router>;
}